import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Autocomplete } from '../Autocomplete';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  LinearProgress,
  Typography,
} from '@material-ui/core';
import PropTypes from 'prop-types';

// SERVICES
import { getValidOrdersForUser } from '../../services';

const styles = props => ({
  darkBlueButton: {
    backgroundColor: '#315382',
    '& *': {
      color: 'white',
    },
  },
});

export const BulkReleaseDialog = withStyles(styles)(props => {
  const {

    rowData,
    show,
    onConfirm,
    //allowAutoReassignment,
    onClose,
  } = props;

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState(null);
  // const [userRestrictedOrderLineIdMessage, setUserRestrictedOrderLineIdMessage] = useState(null);
  const [successfulSubmit, setSuccessfulSubmit] = useState(false);



  useEffect(() => {
setSuccessfulSubmit(false);
    setSubmitMessage(null);
      }, [show]);

  

  const assignOrders = async () => {
    // short circuit and reload the main grid
    if (successfulSubmit) {
      setSuccessfulSubmit(false)
      setSubmitMessage(null);
      return onClose(true);
    }
   

    setSubmitMessage('Releaseing ' + rowData.length + ' order' + rowData.length > 1 ?'s':'' );
   
    const orderTickets = rowData;


    try {
      setIsSubmitting(true);
      const data = await onConfirm(orderTickets);
      
      setSuccessfulSubmit(true);
      
      setSubmitMessage('Order Released successfully!');
      
    } catch (error) {
      setSuccessfulSubmit(false);
      setSubmitMessage(error.message);

    } finally {
      setIsSubmitting(false);
      
    }
  };

  return (
    <Dialog open={show} onClose={() => onClose(false)} aria-labelledby="form-dialog-title">
      <DialogTitle>Bulk Release</DialogTitle>
      <DialogContent
        dividers
        style={{
          minWidth: 500,
          minHeight: 400,
          borderTop: '0.8px solid #ddd',
          borderBottom: '0.8px solid #ddd',
          paddingTop: 20,
          pointerEvents: isSubmitting ? 'none' : 'auto',
          opacity: isSubmitting ? 0.5 : 1,
        }}
      >
        <div>Selected Order Tickets:</div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            marginTop: 3,
            marginBottom: 15,
            minHeight: 25,
            border: !rowData || !rowData.length ? '1px solid #999' : '1px solid black',
            borderRadius: 3,
            padding: 5,
          }}
        >
          {rowData && !!rowData.length ? rowData.join(', ') : ''}
          {!rowData || (!rowData.length && <div style={{ color: '#999' }}>No orders were selected</div>)}
        </div>

        


      </DialogContent>
      <DialogActions
        style={{
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}
      >
        <Button
          onClick={() => onClose(false)}
          variant="contained"
          style={{ backgroundColor: '#315382', color: 'white' }}
        >
          Cancel
        </Button>
        <div style={{ flex: 1, paddingLeft: 10, paddingRight: 10 }}>
          {isSubmitting && <LinearProgress />}
          {submitMessage && <div className="text-center">{submitMessage}</div>}
          
        </div>
        <Button
          disabled={
            isSubmitting
          }
          onClick={assignOrders}
          variant="contained"
          style={{ backgroundColor: '#315382', color: 'white' }}
        >
          {/* {!!userRestrictedOrderLineIdMessage && `Yes, `} */}
          {successfulSubmit
              ? 'Done'
              : 'Release'}
            
        </Button>
      </DialogActions>
    </Dialog>
  );
});

BulkReleaseDialog.propTypes = {
  // inspectorOptions:
  rowData: PropTypes.array.isRequired,
  show: PropTypes.bool.isRequired,
  setDialog: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,

  // dialogValues
  setDialogValues: PropTypes.func,
};

BulkReleaseDialog.defaultProps = {

};
